import React from 'react'
import Home from '../../components/quickbooks/Home'

const QBHome = () => {
  return (
    <Home />
  )
}

export default QBHome